/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Tip_2Inputs */

const tr_katalog_desi_page_tip_2 = /** @type {(inputs: Katalog_Desi_Page_Tip_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç küsuratlıysa kargo firması genelde yukarı yuvarlar.`)
};

const en_katalog_desi_page_tip_2 = /** @type {(inputs: Katalog_Desi_Page_Tip_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the result has decimals, carriers usually round up.`)
};

const de_katalog_desi_page_tip_2 = /** @type {(inputs: Katalog_Desi_Page_Tip_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Nachkommastellen runden Versanddienste meist auf.`)
};

const ru_katalog_desi_page_tip_2 = /** @type {(inputs: Katalog_Desi_Page_Tip_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если есть дробная часть, перевозчики обычно округляют вверх.`)
};

/**
* | output |
* | --- |
* | "If the result has decimals, carriers usually round up." |
*
* @param {Katalog_Desi_Page_Tip_2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_tip_2 = /** @type {((inputs?: Katalog_Desi_Page_Tip_2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Tip_2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_tip_2(inputs)
	if (locale === "de") return de_katalog_desi_page_tip_2(inputs)
	if (locale === "ru") return ru_katalog_desi_page_tip_2(inputs)
	return tr_katalog_desi_page_tip_2(inputs)
});